export default {"src":"/_next/static/media/location.9d2cffe6.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};